import type { Elplan } from 'api/elplan/elplan.api'
import type { ElplanInfo } from 'api/elplan/elplan.types'
import i18n from 'i18next'
import type { DayAheadPlanAction } from './DayAheadPlan.types'

type DayAheadPlanActionInputs = {
  elplanInfo: ElplanInfo | undefined
  plan: Elplan | null | undefined
  hasBidsForDay: boolean | undefined
}

function getCreateActions(elplanInfo: ElplanInfo, hasBidsForDay: boolean | undefined): DayAheadPlanAction[] {
  const hasBidTypes = (elplanInfo.bid_types ?? []).length > 0
  if (!hasBidTypes || hasBidsForDay === undefined) {
    return [{ id: 'empty' }]
  }

  return [
    { id: 'empty' },
    hasBidsForDay ? { id: 'fromBids' } : { id: 'fromBids', disabledReason: i18n.t('There are no bids for this day') },
  ]
}

export function getHasBidsForDay(
  bidsForDay: readonly unknown[] | undefined,
  bidSumMwDataset: Pick<Dataset, 'times'>
): boolean | undefined {
  if (bidsForDay === undefined) {
    return undefined
  }
  if (bidsForDay.length === 0) {
    return false
  }
  return bidSumMwDataset.times.length > 0 ? true : undefined
}

export function getDayAheadPlanActions({
  elplanInfo,
  plan,
  hasBidsForDay,
}: DayAheadPlanActionInputs): DayAheadPlanAction[] {
  if (elplanInfo === undefined || plan === undefined) {
    return []
  }

  const fetchesResults = Boolean(elplanInfo.integration) && elplanInfo.supports_results !== false
  const fetchResults: DayAheadPlanAction[] = fetchesResults && !plan?.is_locked ? [{ id: 'fetchResults' }] : []
  if (plan === null) {
    return [...fetchResults, ...getCreateActions(elplanInfo, hasBidsForDay)]
  }

  const edit: DayAheadPlanAction[] = plan.is_locked ? [] : [{ id: 'edit' }]
  return [...fetchResults, ...edit, { id: 'lock' }]
}
